import {
    apiRequest,
    positionBknDetail, 
    positionBknUpdate,
} from "../../../../../services/adapters/master/positionBknService"

class IndexRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", positionBknDetail, {
            params: query
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", positionBknUpdate, {
            body: query
        }, true)
    }

}

export default IndexRepository